import cnvrgnxLogo from "@/assets/cnvrgnx-logo.png";
import { cn } from "@/lib/utils";

interface LogoProps {
  variant?: 'full' | 'compact' | 'icon';
  showModule?: boolean;
  showVersion?: boolean;
  version?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: { logo: 'h-5', module: 'text-[10px]', version: 'text-[8px]', icon: 'text-sm' },
  md: { logo: 'h-6', module: 'text-xs', version: 'text-[10px]', icon: 'text-base' },
  lg: { logo: 'h-8', module: 'text-sm', version: 'text-xs', icon: 'text-lg' },
  xl: { logo: 'h-10', module: 'text-base', version: 'text-sm', icon: 'text-xl' },
};

export function Logo({
  variant = 'full',
  showModule = false,
  showVersion = false,
  version,
  className,
  size = 'md',
}: LogoProps) {
  const sizes = sizeMap[size];

  if (variant === 'icon') {
    return (
      <span className={cn("font-preospe tracking-wider text-foreground", sizes.icon, className)}>
        C
      </span>
    );
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img
        src={cnvrgnxLogo}
        alt="CNVRGNX Logo"
        className={cn("object-contain", sizes.logo)}
      />
      {(showModule || showVersion) && (
        <div className="flex flex-col">
          {showModule && (
            <span className={cn("font-michroma text-foreground/80", sizes.module)}>
              XSM
            </span>
          )}
          {showVersion && version && (
            <span className={cn("text-muted-foreground font-sans", sizes.version)}>
              v{version}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default Logo;
